"use strict";
// @ts-ignore
try {
    self['workbox:recipes:7.3.0'] && _();
}
catch (e) { }
